"use client";

import clsx from "clsx";
import type { AssetClass } from "@/stores/strategiesStore";

const ASSET_CLASS_STYLES: Record<AssetClass, string> = {
  futures: "bg-blue-500/15 text-blue-400",
  crypto: "bg-orange-500/15 text-orange-400",
  equities: "bg-emerald-500/15 text-emerald-400",
  forex: "bg-purple-500/15 text-purple-400",
};

const ASSET_CLASS_LABELS: Record<AssetClass, string> = {
  futures: "Futures",
  crypto: "Crypto",
  equities: "Equities",
  forex: "Forex",
};

interface AssetClassBadgeProps {
  assetClass: AssetClass;
  size?: "sm" | "md";
}

export const AssetClassBadge = ({ assetClass, size = "sm" }: AssetClassBadgeProps) => {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full font-medium",
        ASSET_CLASS_STYLES[assetClass],
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-0.5 text-xs"
      )}
    >
      {ASSET_CLASS_LABELS[assetClass]}
    </span>
  );
};
